import React, { useState } from 'react';
import { Bell } from 'lucide-react';
import { NotificationCenter } from './NotificationCenter';
import { useNotificationFeed } from './useNotificationFeed';

interface NotificationBellProps {
  className?: string;
}

export const NotificationBell: React.FC<NotificationBellProps> = ({ className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    notifications,
    unreadCount,
    loading,
    fetchNotifications,
    markAsRead,
    markAllAsRead,
    deleteNotification,
  } = useNotificationFeed();

  const openCenter = () => {
    setIsOpen(true);
    fetchNotifications(false);
  };

  const closeCenter = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button
        onClick={openCenter}
        className={`relative p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors ${className}`}
        title="Notifications"
      >
        <Bell className="w-5 h-5" />
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] rounded-full h-5 min-w-[20px] px-1 flex items-center justify-center font-semibold">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
        {unreadCount === 0 && (
          <span className="absolute top-0 right-0 h-2 w-2 bg-transparent rounded-full" aria-hidden />
        )}
      </button>

      <NotificationCenter
        isOpen={isOpen}
        notifications={notifications}
        loading={loading}
        onClose={closeCenter}
        onRefresh={() => fetchNotifications(false)}
        onMarkRead={markAsRead}
        onMarkAllRead={markAllAsRead}
        onDelete={deleteNotification}
      />
    </>
  );
};
